import { http } from "@/composables/api/http";

// API карточек (ms.cards). См. api_swagger/cards.json.
//
// Актуальный контракт: карточка (card) — глобальная сущность (глобальный
// DELETE /cards/{card_id}), а работа со статьёй внутри проекта идёт через
// /cards/article/{article_id}?project_id=... — get / patch / delete.
// Ранее использовавшиеся GET /cards/{id} и PATCH /cards/{id} из спеки убраны.
export const cardsApi = {
    // POST /cards/search — фасетный поиск карточек в проекте.
    search(body, config = {}) {
        return http.post("/cards/search", body, config).then((r) => r.data);
    },

    // GET /cards/article/{article_id}?project_id=... — детали статьи в проекте.
    getArticle(articleId, projectId) {
        return http.get(`/cards/article/${articleId}`, { params: { project_id: projectId } }).then((r) => r.data);
    },

    // PATCH /cards/article/{article_id}?project_id=... — обновление проектных
    // полей статьи (sentiment / importance / is_favourite).
    updateArticle(articleId, projectId, body) {
        return http.patch(`/cards/article/${articleId}`, body, { params: { project_id: projectId } });
    },

    // DELETE /cards/article/{article_id}?project_id=... — удалить статью
    // только из текущего проекта (карточка остаётся в других проектах).
    deleteArticle(articleId, projectId) {
        return http.delete(`/cards/article/${articleId}`, { params: { project_id: projectId } });
    },

    // DELETE /cards/{card_id} — удалить карточку полностью (глобально).
    remove(cardId) {
        return http.delete(`/cards/${cardId}`);
    },

    // POST /cards/reindex — переиндексация OpenSearch (админский эндпоинт).
    reindex() {
        return http.post("/cards/reindex");
    },
};
